export default "__VITE_ASSET__353bda31__"